import type { Competition } from "@/data/competitions";

const fmt = (iso: string) => {
  const d = new Date(iso);
  return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
};

export const downloadCompIcs = (c: Competition) => {
  const end = new Date(c.endDate);
  end.setDate(end.getDate() + 1); // make end-date inclusive
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Swell Atlas//Surf Comps//EN",
    "BEGIN:VEVENT",
    `UID:${c.id}@swell-atlas`,
    `DTSTAMP:${fmt(new Date().toISOString())}`,
    `DTSTART:${fmt(c.startDate)}`,
    `DTEND:${fmt(end.toISOString())}`,
    `SUMMARY:${c.name}`,
    `LOCATION:${c.location}, ${c.country}`,
    `DESCRIPTION:${c.tour} — Break: ${c.break}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${c.id}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};